<!-- Initial configuration state -->
@if (!batchId()) {
  <div class="bulk-download-configuration">
    @if (loadingCount()) {
      <div class="loading-container">
        <p-progressspinner strokeWidth="4" [style]="{ width: '50px', height: '50px' }" />
        <span>Loading certificate count...</span>
      </div>
    } @else {
      <div class="configuration-content">
        <p class="description">
          Download certificates for approved systems as a zip file organized by GL and system type.
        </p>

        <!-- Year Selection -->
        <div class="form-section">
          <label class="section-label">Certification Year</label>
          <div class="radio-group">
            <div class="radio-option">
              <p-radiobutton
                name="year"
                [value]="nextYear"
                [(ngModel)]="certificationYear"
                inputId="year-next"
              />
              <label for="year-next">{{ nextYear }} (Next Year)</label>
            </div>
            <div class="radio-option">
              <p-radiobutton
                name="year"
                [value]="currentYear"
                [(ngModel)]="certificationYear"
                inputId="year-current"
              />
              <label for="year-current">{{ currentYear }} (Current Year)</label>
            </div>
          </div>
        </div>

        <!-- Type Filter Selection -->
        <div class="form-section">
          <label class="section-label">Certificate Type</label>
          <div class="radio-group">
            @for (option of typeFilterOptions; track option.value) {
              <div class="radio-option">
                <p-radiobutton
                  name="typeFilter"
                  [value]="option.value"
                  [(ngModel)]="typeFilter"
                  [inputId]="'type-' + option.value"
                />
                <label [for]="'type-' + option.value">{{ option.label }}</label>
              </div>
            }
          </div>
        </div>

        <p-divider />

        <!-- Certificate Count Preview -->
        <div class="count-preview">
          <span class="label">Certificates to download:</span>
          <span class="value" [class.zero]="certificateCount() === 0">{{ certificateCount() }}</span>
        </div>

        <div class="info-note">
          <i class="pi pi-info-circle"></i>
          <span>
            Certificates will be organized in folders by General Licensee (GL) and system prefix.
          </span>
        </div>

        <div class="actions">
          <p-button
            label="Cancel"
            severity="secondary"
            [text]="true"
            (onClick)="close()"
          />
          <p-button
            label="Start Download"
            icon="pi pi-download"
            [loading]="starting()"
            [disabled]="certificateCount() === 0 || starting()"
            (onClick)="startDownload()"
          />
        </div>
      </div>
    }
  </div>
}

<!-- Progress state -->
@if (batchId()) {
  <div class="bulk-download-progress">
    <div class="progress-header">
      <span class="status-text">
        @if (isComplete() && !isFailed()) {
          <i class="pi pi-check-circle success-icon"></i>
          Download Ready
        } @else if (isFailed()) {
          <i class="pi pi-times-circle error-icon"></i>
          Download Failed
        } @else {
          <p-progressspinner strokeWidth="4" [style]="{ width: '20px', height: '20px' }" />
          Packaging certificates...
        }
      </span>
    </div>

    <div class="progress-summary">
      <span class="count">{{ status()?.processedCount ?? 0 }} / {{ status()?.totalCount ?? 0 }}</span>
      <p-progressbar [value]="progressPercent()" [showValue]="false" />
    </div>

    <div class="status-details">
      <div class="detail-row">
        <span class="label">Year:</span>
        <span class="value">{{ certificationYear() }}</span>
      </div>
      <div class="detail-row">
        <span class="label">Type:</span>
        <span class="value">{{ typeFilter() === 'All' ? 'All Certificates' : typeFilter() }}</span>
      </div>
      <div class="detail-row">
        <span class="label">Processed:</span>
        <span class="value" [class.success]="isComplete() && !isFailed()">
          {{ status()?.processedCount ?? 0 }}
        </span>
      </div>
    </div>

    @if (isFailed() && status()?.error) {
      <p-divider />
      <div class="error-message">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ status()?.error }}</span>
      </div>
    }

    @if (isComplete() && !isFailed()) {
      <p-divider />
      <div class="completion-info">
        <p>
          <i class="pi pi-check-circle success-icon"></i>
          Your zip file is ready for download.
        </p>
      </div>
    }

    <div class="actions">
      @if (canDownload()) {
        <p-button
          label="Download Zip"
          icon="pi pi-download"
          [loading]="downloading()"
          (onClick)="downloadZip()"
        />
      }
      <p-button
        [label]="isComplete() || isFailed() ? 'Close' : 'Close (Processing will continue)'"
        severity="secondary"
        [text]="!isComplete() && !isFailed()"
        [disabled]="!canClose()"
        (onClick)="close()"
      />
    </div>
  </div>
}
